import React, { Component } from 'react';
import CustomButton from '../CustomButton';
import styles from './Registration.module.css';
import VerifyEmailIcon from '../svgs/VerifyEmailIcon';
import { authentication } from '../../../../shared/models/Authentication';
import { logVerifyEmail } from '../../../../shared/models/Analytics';
import { withRouter } from 'react-router-dom';
import { rwbApi } from '../../../../shared/apis/api';
import AlertDialog from '../AlertDialog';
import Loading from '../Loading';
import { projectConfig } from '../../../../shared/project-info/projectConfig';
import { GENERIC_ERROR, INVALID_CONFIRMATION_CODE } from '../../../../shared/constants/ErrorMessages';
import { errorAlert } from '../../../../shared/utils/ErrorAlert';
import { userProfile } from '../../../../shared/models/UserProfile';
import registerProfileFlow from '../../../../shared/utils/RegisterProfileFlow';
import { tenantProjectInfo } from '../../../../shared/models/TenantProjectInfo';

class RegisterVerifyEmail extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      showDialog: false,
      confirmationCode: new Array(projectConfig.verificationCodeLength).fill(''),
      errorMessage: '',
      userEmail:""
    };
  }

  logout = () => {
    authentication.deleteAuthentication();
    tenantProjectInfo.clearStoredValues();
    this.props.history.replace('/login');
  };

  // may not be needed
  componentDidMount() {
    this.checkVerification();
    this.setState({
      userEmail:userProfile.getUserProfile().email
    })
  }

  checkVerification = () => {
    const { history } = this.props;
    this.setState({
      isLoading: true,
    });
    rwbApi
      .getUser()
      .then((response) => {
        const { email_verified, profile_completed } = response;
        if (email_verified === true && profile_completed === false) {
          const firstScreen = registerProfileFlow.getFirstScreen();
          history.push(`/registration/${firstScreen.path}`);
        } else if (email_verified === true && profile_completed === true) {
          this.props.history.replace('/feed');
        } else {
          this.setState({
            // showDialog: true,
            isLoading: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          isLoading: false,
        });
        alert('There was an error contacting the server. Please try again.');
      });
  };

  verifyEmail = () => {
    this.setState({errorMessage: ''});
    logVerifyEmail();
    const code = this.state.confirmationCode.join('');
    rwbApi.verifyEmail(code)
    .then((response) => {
      this.setState({ codeError: false });
      return rwbApi.getUser();
    })
    .then((user) => {
      if (projectConfig.hasWorkspaces && user.workspace == null) {
        this.props.history.push('/registration/work_space');
      } else {
        const firstScreen = registerProfileFlow.getFirstScreen();
        this.props.history.push(`/registration/${firstScreen.path}`);
      }
    })
    .catch((err) => {
      if (err.toString() === 'Error: Unable to verify email.') {
        this.setState({errorMessage: INVALID_CONFIRMATION_CODE.toUpperCase()});
      } else {
        errorAlert(GENERIC_ERROR);
      }
    })
  }

  updateCode = (index, event) => {
    let code = this.state.confirmationCode;
    let value = event.target.value;
    // Safari ignores type number and inputmode of numeric also does not prevent letters from being typed.
    // having type of number prevents onchange from being called with letters but on safari the letters can still be typed and will display
    if (Number.isNaN(Number(value))) return;
    // the user can press a new number after backspacing, keep the original number and prevent getting double digits
    if (value.length > 1) {
      value = value.charAt(0);
    }
    const currentValue = code[index];
    code[index] = value;
    // focus into next or previous input
    const newIndex = value !== '' ? index + 1 : index - 1;
    if (newIndex >= 0 && newIndex < projectConfig.verificationCodeLength) {
      if ((currentValue === '' && value !== '') || (currentValue === '' && value === ''))
        document.getElementById(`codeInput-${newIndex}`).focus();
    }
    // prevent manual input of more numbers
    if (currentValue === '' && parseInt(value) <= 9) {
      this.setState({ confirmationCode: code });
    }
  }

  handlePaste = (e) => {
    let pastedData = e?.clipboardData?.getData('Text').split('').slice(0,6);
    if (pastedData) {
      let lastValidIndex = 0;
      for (let i = 0; i < 6; i++) {
        if (!pastedData[i] || Number.isNaN(Number(pastedData[i]))) pastedData[i] = '';
        else lastValidIndex = i;
      }
      this.setState({confirmationCode: pastedData});
      document.getElementById(`codeInput-${lastValidIndex}`).focus();
    }
  }

  handleBack = (index, event) => {
    // this function is called on key down and picks up all key events
    // if the key down is a "." prevent it from being added
    if (event.keyCode === 190) event.preventDefault();
    // backbutton
    if (event.keyCode === 8) {
      this.setState({errorMessage: ''});
      let code = this.state.confirmationCode;
      const inputValue = this.state.confirmationCode[index];
      if (inputValue === '' && index > 0) {
        document.getElementById(`codeInput-${index - 1}`).focus();
      }
      code[index] = '';
      this.setState({ confirmationCode: code });
    }
  }

  render() {
    const { isLoading, showDialog } = this.state;
    const totalSteps = registerProfileFlow.getTotalSteps();
    return (
      <div className={styles.container}>
        <Loading size={100} color={'var(--white)'} loading={isLoading} />
        <div className={styles.headerContainer}>
          <h3 className="title">{projectConfig.verificationAccountTitle}</h3>
          <p className="titleSubheader">Step 2 of {totalSteps}</p>
        </div>
        <div className={styles.contentContainer}>
          <div>
            <VerifyEmailIcon width="100%" height={65} />
            <div className={styles.verifyEmailContent}>
             <p className={styles.userEmailText}>
                {this.state.userEmail}
              </p>
              <p>
                {projectConfig.emailConfirmationText}
              </p>
              <br />
              <p>
                {projectConfig.enterConfirmationCodeText}
              </p>
            </div>
          </div>
          {projectConfig.verificationType === 'code' && (
            // verification code
            <div>
              {new Array(projectConfig.verificationCodeLength).fill(0).map((value, index) => {
                return (
                  <input value={this.state.confirmationCode[index]} autoFocus={index === 0}
                    id={`codeInput-${index}`} key={`codeInput-${index}`} className={styles.codeInput} max={9} min={0} maxLength={1} autoComplete='off'
                    onChange={(event) => this.updateCode(index, event)} onKeyDown={(event) => this.handleBack(index, event)} onPaste={this.handlePaste}/>
                )
              })}
              <p className='errorMessage' style={{marginLeft: 5, marginTop: 5}}>{this.state.errorMessage}</p>
            </div>
          )}

          <div className={styles.buttonContainer}>
            <p className={styles.noEmail}>
              Didn&apos;t receive the email? <br />
              Check your spam folder or{' '}
              <a className="link" href={`mailto:${projectConfig.supportEmail}`}>
                contact us
              </a>{' '}
              for help.
            </p>
            <CustomButton
              onClick={this.verifyEmail}
              label={projectConfig.verificationType === 'code' ? 'NEXT' : "I'VE VERIFIED MY EMAIL"}
              disabled={this.state.confirmationCode.indexOf('') !== -1}
              buttonStyle={'primary'}
              customStyles={this.state.confirmationCode.indexOf('') !== -1 ? { opacity: '50%', cursor: 'initial' } : {}}
            />
            <CustomButton
              onClick={this.logout}
              label={'Not you? Back to login.'}
              buttonStyle={'secondary'}
            />
          </div>
        </div>
        <AlertDialog
          text={
            `Please check your email inbox for a link from ${projectConfig.name}. If you're still having trouble, contact support.`
          }
          open={showDialog}
          handleClose={() => this.setState({ showDialog: false })}
        />
      </div>
    );
  }
}

export default withRouter(RegisterVerifyEmail);
